export const mockWizardContent = {
  global: {
    logo_main: "meedLogo.png",
    terms_text:
      "By signing up for and using the meed Platform, you agree to our Terms of Service.",
    terms_link: "https://www.meedloyalty.com/terms-of-use",
    button_back: "Back",
    button_submitting: "Processing...",
    button_loading: "Loading...",
  },
  step0_emailVerification: {
    title_initial: "Ready to Turn Customers into Your Biggest Fans?",
    title_otpSent: "Enter Your Code",
    description_initial:
      "Let's create your bar's Checkin program in a few quick steps.",
    prompt_initial: "First, what email address would you like to use?",
    description_otpSent: "We sent a 4-digit code to {email}.",
    image_main: "bar-sign-placeholder.png",
    input_email_placeholder: "you@yourbar.com",
    button_submit: "Let's Go!",
    button_verify: "Verify & Continue",
    button_verify_submitting: "Verifying...",
    button_resend_code: "Resend code",
    button_resend_cooldown: "Resend code in {seconds}s",
    hero_image: "patronReceivingCocktailPlaceholder.jpg",
  },
  step1_usersFirstName: {
    title: "Welcome to meed",
    icon: "beerMugIconPlaceholder.png",
    prompt: "What should we call you?",
    description:
      "Just your first name for now – we like to keep things friendly.<br/>We'll get more formal if you decide to upgrade later!",
    input_firstName_placeholder: "Your first name",
    button_next: "Next Step",
    hero_image: "newUserHoldingPhoneImagePlaceholder.jpg",
  },
  step2_businessDetails: {
    title: "Tell Us About Your Bar",
    label_businessName: "What's the full name of your bar?",
    input_businessName_placeholder: "All Bar None",
    note_businessName:
      "This will be the name of your loyalty program too. You can change it later.",
    label_address: "Where can thirsty customers find you?",
    input_address_placeholder: "97 Midway Drive",
    note_address: "Helps with Google Maps!",
    label_country: "Which country are you in?",
    input_country_placeholder: "Select a country",
    button_next: "Continue",
    hero_image: "phoneWithQRPlaceholder.jpg",
  },
  step3_branding: {
    title: "Make Your Bar Shine",
    label_logo: "Upload your bar's logo",
    uploader_message: "Drop files here or browse",
    uploader_notes:
      "Supported format: PNG, JPG.<br/>Clear square logo works best, 350x350px or larger.",
    label_brandColor: "Pick your pass and voucher colour",
    note_brandColor:
      "This will be the colour of your customer's membership card.",
    button_next: "Looks Great!",
    button_uploading: "Uploading...",
    hero_image: "phoneWithBlueCocktailPlaceholder.jpg",
  },
  step4_rewardCreation: {
    title: "Keep Them Coming Back",
    label_rewardName: "Name a reward",
    input_rewardName_placeholder: "Cash for Beers",
    note_rewardName:
      "This is the reward they get for filling the card by checking in. 20 characters maximum.",
    label_checkinValue: "How many Checkins to win this reward?",
    input_checkinValue_placeholder: "Select Checkin Value",
    note_checkinValue:
      "This is how many times they need to visit and Checkin to win the reward.",
    note_stampCard: "Your stamp card will be valid for one year by default.",
    button_next: "Design Reward",
    hero_image: "bartenderServingCocktailPlaceholder.jpg",
  },
  step5_rewardDetails: {
    title: "Details, Details!",
    label_offerDescription: "Briefly describe the offer",
    input_offerDescription_placeholder:
      "Checkin six times and get 20% off your next bill",
    note_offerDescription: "Tell customers what they are signing up for.",
    label_rewardType: "What type of reward is it?",
    button_rewardType_percentage: "% Discount",
    button_rewardType_cash: "$ Cash",
    button_rewardType_item: "Item",
    input_percentage_placeholder: "Choose Percentage Discount Amount",
    input_cash_placeholder: "Enter cash amount (e.g., 50)",
    input_item_placeholder: "Enter item name (e.g., Free Coffee)",
    label_rewardImage: "Add a photo to showcase the reward",
    uploader_message: "Browse photo gallery",
    note_rewardImage:
      "This photo will appear on the stamp card and the voucher when earned. Square image best, larger than 350x350 px.",
    button_next: "Almost Done!",
    hero_image: "phoneWithAppBlueScreenPlaceholder.jpg",
  },
  step6_businessDescription: {
    title: "Just One More Thing...",
    label_barDescription: "Tell us about your bar",
    input_barDescription_placeholder:
      "All Bar None is Hong Kong's best bar for beer and sports.",
    note_barDescription:
      "This is your chance to shine! We'll show this on the customer's meed web app when they want to learn more about your loyalty program.",
    button_next: "Launch My Program",
    hero_image: "patronReceivingCocktailPlaceholder.jpg",
  },
  successScreen: {
    icon: "youAreLiveIconPlaceholder.png",
    title: "You Are Live!",
    description:
      "You're all set! Your customers can now start earning rewards with just a quick Checkin.<br/>Launch the Dashboard or get your QR code right now for your customers to scan and join.",
    button_dashboard: "Launch Dashboard",
    button_getQR: "Get QR Code",
    button_tutorialVideo: "Launch Tutorial Video",
    link_tutorialVideo:
      "https://www.youtube.com/playlist?list=PLByPzs610Nk37OXooWiB7Ut0mMMRCuXzU",
    button_tutorialBlog: "Visit Tutorial Blog",
    link_tutorialBlog:
      "https://www.meedloyalty.com/blog/categories/tutorials-how-to",
    hero_image: "phoneWithCheckinStatusPlaceholder.jpg",
  },
  existingUserScreen: {
    title: "Welcome Back!",
    icon: "meedMascotBartenderPlaceholder.png",
    description:
      "Looks like you already have a meed account! Please log into the portal.",
    button_next: "Take Me There!",
    hero_image: "phoneWithQRPlaceholder.jpg",
  },
  modals_notifications: {
    progressModal_title: "Setting up your Loyalty Program",
    progressModal_step1: "Creating Account",
    progressModal_step2: "Creating Organization",
    progressModal_step3: "Setting up Loyalty Program",
    progressModal_step4: "Setting up Location",
    progressModal_step5: "Creating Welcome Voucher",
    qrModal_title: "Your Program QR Code",
    qrModal_description:
      "Customers can scan this QR code to join your loyalty program and check in.",
    qrModal_button_download: "Download QR Code",
    notification_businessNameTaken_title: "Business Name Taken",
    notification_businessNameTaken_description:
      'The name "{businessName}" is already taken. We\'ve changed it to "{newBusinessName}". You can change this later in your organization settings.',
    notification_success_title: "Success",
    notification_success_description:
      "Your loyalty program has been created successfully!",
  },
  features: {
    "check-in": true,
    autoVoucherIsOneTimeUse: false,
    IsSelectIndustryEnabled: true,
    Industry: 2, // Default to "Food & Beverages" ID
  },
};

export const mockWizards = [
  {
    wizardId: "checkin-for-bars",
    name: "Default Bar Onboarding",
    modifiedAt: "2023-10-27T10:00:00Z",
    content: mockWizardContent,
  },
  {
    wizardId: "holiday-special",
    name: "Holiday Special 2023",
    modifiedAt: "2023-10-25T15:30:00Z",
    content: {
      ...mockWizardContent,
      step0_emailVerification: {
        ...mockWizardContent.step0_emailVerification,
        title_initial: "Ready for the Holidays?",
      },
    },
  },
];

// In a real app, you'd use something like React Query's useQuery hook
// to call these, but for now, we export them directly.

export const getWizards = () => {
  return Promise.resolve(
    mockWizards.map((w) => ({
      wizardId: w.wizardId,
      name: w.name,
      modifiedAt: w.modifiedAt,
    })),
  );
};

export const getWizardById = (id: string) => {
  const wizard = mockWizards.find((w) => w.wizardId === id);
  return Promise.resolve(wizard);
};
